import { render, staticRenderFns } from "./productionStation.vue?vue&type=template&id=fe5ae068&"
import script from "./productionStation.vue?vue&type=script&lang=js&"
export * from "./productionStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports